import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./TrainersPage.scss";
import useAppSelector from "../../hooks/useAppSelector";
import Spinner from "../../components/Spiner/Spinner";
import Slider from "react-slick";
import {getTrainerImage} from "../../helpers/image.helper";
import {useNavigate} from "react-router-dom";

const TrainersPage = () => {

    const {activeGym} = useAppSelector(state => state.multiGymsSlice);
    const {classes, isClassesLoading} = useAppSelector(state => state.classesSlice);
    const {visibleTrainer, isTrainerLoading} = useAppSelector(state => state.trainersSlice);

    const navigate = useNavigate();

    if (isClassesLoading || isTrainerLoading) {
        return (
            <Spinner/>
        )
    }

    function SamplePrevArrowClassesSlider(props: any) {
        const {className, onClick} = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.7598 24.0938L4.66643 16.0004L12.7598 7.90708" stroke="#292D32" strokeWidth="1.5"
                          strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M27.334 16L4.89398 16" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10"
                          strokeLinecap="round" strokeLinejoin="round"/>
                </svg>

            </div>
        );
    }

    function SampleNextArrowClassesSlider(props: any) {
        const {className, onClick} = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.2402 7.90625L27.3336 15.9996L19.2402 24.0929" stroke="#292D32" strokeWidth="1.5"
                          strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4.66602 16H27.106" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10"
                          strokeLinecap="round" strokeLinejoin="round"/>
                </svg>

            </div>
        );
    }

    const classesSliderSettings = {
        className: "slider variable-width classes-carousel",
        swipe: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: true,
        centerMode: true,
        prevArrow: <SamplePrevArrowClassesSlider/>,
        nextArrow: <SampleNextArrowClassesSlider/>,
        responsive: [
            {
                breakpoint: 650,
                settings: {
                    swipe: true,
                    slidesToScroll: 2,
                }
            },
        ]
    };

    function CustomSlide(props: any) {
        const { trainer } = props;
        return (
            <div onClick={() => navigate(`/trainers/${trainer.id}`)} className={"trainer-item"} style={{backgroundImage: `url(${getTrainerImage(activeGym.endpoint, trainer)})`}}>
                <p className={"name"}>{trainer.firstname} {trainer.lastname}</p>
            </div>
        );
    }

    function SamplePrevArrowTrainerSlider(props: any) {
        const {className, onClick} = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="36" cy="36" r="36" fill="#505050" fillOpacity="0.5"/>
                    <path d="M31.9492 46.1172L21.8326 36.0005L31.9492 25.8839" stroke="white" strokeWidth="1.5"
                          strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M50.166 36L22.116 36" stroke="white" strokeWidth="1.5" strokeMiterlimit="10"
                          strokeLinecap="round" strokeLinejoin="round"/>
                </svg>


            </div>
        );
    }

    function SampleNextArrowTrainerSlider(props: any) {
        const {className, onClick} = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="36" cy="36" r="36" transform="rotate(-180 36 36)" fill="#505050" fillOpacity="0.5"/>
                    <path d="M40.0508 25.8828L50.1674 35.9995L40.0508 46.1161" stroke="white" strokeWidth="1.5"
                          strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M21.834 36L49.884 36" stroke="white" strokeWidth="1.5" strokeMiterlimit="10"
                          strokeLinecap="round" strokeLinejoin="round"/>
                </svg>


            </div>
        );
    }

    const trainersSliderSettings = {
        className: "trainers-carousel",
        swipe: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        centerPadding: "300px",
        nextArrow: <SampleNextArrowTrainerSlider/>,
        prevArrow: <SamplePrevArrowTrainerSlider/>,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1140,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "200px",
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "100px",
                    swipe: true
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "50px",
                    swipe: true
                }
            }
        ]
    }

    return (
        <div className={"trainers-page"}>
            <section className={"classes-wrapper"}>
                <Slider {...classesSliderSettings}>
                    {
                        classes.map((el) => {
                            return (
                                <div className={`classes-item`} key={el.id}>
                                    {el.name}
                                </div>
                            )
                        })
                    }
                </Slider>
            </section>
            <section className={"trainers-wrapper"}>
                <Slider {...trainersSliderSettings}>
                    {
                        visibleTrainer.map(el => {
                            return (
                                <CustomSlide key={el.id} trainer={el}/>
                            )
                        })
                    }
                </Slider>
            </section>
        </div>
    )
}

export default TrainersPage;